export const projectsDb = [
  {
    title: 'Product Hunt',
    url: 'https://github.com/danisan9490/product-hunt-clone',
    description: 'Clone of the website that lets you share and discover products.',
    lifeWeb: 'https://product-hunt-be03f.web.app/',
    img: 'producthunt',
    category: "fullStack"
  },
  {
    title: 'Projects Manager',
    url: 'https://github.com/danisan9490/MERN-task-manager',
    description: 'The easy and visual way to manage your projects and tasks.',
    lifeWeb: 'https://stackmerntasks.netlify.app',
    img: 'projectManager',
    category: "fullStack"
  },
  {
    title: 'Light-Dark Mode',
    url: 'https://github.com/danisan9490/template-CV2-light-dark-mode',
    description: 'CV template that follows the new tendencies of websites.',
    lifeWeb: 'https://danisan9490.github.io/template-CV2-light-dark-mode/',
    img: 'darkLight',
    category: "fullStack"
  },
  {
    title: 'Face Recognition',
    url: 'https://github.com/danisan9490/face-recognition-js',
    description: 'Full website able to find a face position on a digital image.',
    lifeWeb: '',
    img: 'faceRecognition',
    category: "fullStack"
  },
  {
    title: 'CodeCoin',
    url: 'https://github.com/danisan9490/codeCoin-solo-project',
    description: 'A new blockchain-based cryptocurrency.',
    lifeWeb: '',
    img: 'codeCoin',
    category: "fullStack"
  },
  {
    title: 'Brite U',
    url: 'https://github.com/danisan9490/brite-U-eCommerce-project',
    description: 'eCommerce based on electric scooters and bicycles.',
    lifeWeb: '',
    img: 'briteU',
    category: "fullStack"
  }

]